<template>
    <az-container>
        <div class="mb-2">
            <campo-apresentacao label-padrao="Nome" :text="nomeUsuario | textoSemValorSimples"/>
        </div>

        <div class="mb-2">
            <campo-apresentacao label-padrao="Documento" :text="documentoUsuario | formataCpfCnpj"/>
        </div>

        <div>
            <campo-apresentacao label-padrao="Anexo" :text="nomeAnexo | textoSemValorSimples" :maxTruncate="50"/>
        </div>
    </az-container>
</template>

<script>
    import CampoApresentacao from '@/views/components/campos/CampoApresentacao.vue'
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/core/constants'

    export default {
        name: 'AssinaturaEletronica',

        components: {
            CampoApresentacao,
        },

        data() {
            return {
                nomeUsuario: '',
                documentoUsuario: '000.000.000-00',
            }
        },

        props: {
            nomeAnexo: {
                type: String,
                required: true,
            }
        },

        created() {
            this.capturaDadosUsuario()
        },

        methods: {
            ...mapActions({
                buscarDadosSessaoUsuario: actionTypes.COMUM.BUSCAR_DADOS_SESSAO_USUARIO,
                assinaturaEletronicaDocumento: actionTypes.DOCUMENTO.ASSINATURA_ELETRONICA,
            }),
            async capturaDadosUsuario() {
                const user = await this.buscarDadosSessaoUsuario()
                this.nomeUsuario = user.nome
                this.documentoUsuario = user.docChave
            },
            async assinar({ idExterno }) {
                await this.assinaturaEletronicaDocumento(idExterno)
                    .then(() => {
                        this.mostrarNotificacaoSucesso('Documento assinado com sucesso')
                        this.$emit('cancelar')
                        this.$emit('assinatura-realizada')
                    })
            }
        }
    }
</script>
